import React, { useEffect, useState } from "react";
import "./Voting.css";
import { useNavigate, useParams } from "react-router-dom";
import { checkAuth, getEventById, getProjectById, vote } from "../../services";

export const Voting = () => {
  const { id } = useParams();
  const votes = [1, 2, 3, 4, 5];
  const [selectedVote, setSelectedVote] = useState(0);
  const [selectedIdea, setSelectedIdea] = useState(0);
  const [selectedEco, setSelectedEco] = useState(0);
  const [amount, setAmount] = useState("");
  const [show, setShow] = useState(false);
  const [project, setProject] = useState(null);
  const navigate = useNavigate();
  const [minmax, setMinmax] = useState({ min: 0, max: 1000000 });
  const [errMssg, showError] = useState(false);
  const [errorText, setErrorText] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      const auth = await checkAuth();
      console.log(auth);
      setLoading(true);

      setAmount("");
      setSelectedVote(0);
      setSelectedIdea(0);
      showError(false);
      setProject(null);
      if (!auth.log) {
        window.localStorage.removeItem("judge_code");
        window.localStorage.removeItem("judge_id");
        navigate("/login");
        return;
      }
      const { data, error } = await getProjectById(auth.event_id, id);
      if (error) {
        navigate("/end");
      }
      setProject(data);
      const event = await getEventById(auth.event_id);
      setMinmax({
        min: parseInt(event.data.min_funding_threshold),
        max: parseInt(event.data.max_funding_threshold),
      });
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    })();
  }, [id]);

  const formatNumberWithCommas = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const formatAmount = (num) => {
    return parseInt(num.replace(/[^\d]/g, ""), 10);
  };

  const handleInputChange = (e) => {
    let value = e.target.value.replace(/[^\d]/g, "");

    setShow(false);
    let num = parseInt(value, 10);

    if (!isNaN(num)) {
      setAmount(`֏ ${formatNumberWithCommas(num)}`);
    } else {
      setAmount("");
    }
    if (num < minmax.min || num > minmax.max) {
      setShow(true);
      return;
    }
  };

  const handleSubmit = async () => {
    console.log(minmax);

    if (selectedVote === 0 || selectedIdea === 0 || selectedEco === 0) {
      setErrorText("Please Vote !");
      showError(true);
      setTimeout(() => {
        showError(false);
      }, 3000);
      return;
    }
    if (
      formatAmount(amount) < minmax.min ||
      formatAmount(amount) > minmax.max
    ) {
      setShow(true);
      return;
    }

    if (amount == "" && minmax.max != 0) {
      setErrorText("Amount is required");
      showError(true);
      setTimeout(() => {
        showError(false);
      }, 3000);
      return;
    }
    const sendData = {
      judge: parseInt(window.localStorage.getItem("judge_id")),
      project: project.id,
      score: selectedVote + selectedIdea + selectedEco,
      donation_amount: amount == "" ? 0 : formatAmount(amount).toString(),
    };
    const { data, error } = await vote(sendData);
    if (data?.message === "Vote submitted successfully") {
      navigate(`/voting/${parseInt(id) + 1}`);
    } else {
      setErrorText("Something went wrong, next in 3 sec");
      showError(true);
      setTimeout(() => {
        navigate(`/voting/${parseInt(id) + 1}`);
      }, 3000);
    }
  };

  return (
    <div className="voting">
      <div className="voting_block">
        {!loading ? (
          <>
            <img
              src={`https://api.chill-with-tech.gitc.am/${project?.image}`}
              alt=""
            />
            <div className="voting_info">
              <div className="voting_info_top">
                <h3>{project?.name}</h3>
                {/* <p>{project?.description}</p> */}
                <h4>
                  Իրատեսություն
                </h4>

                <div className="voting_rate">
                  {votes.map((vote, i) => {
                    return (
                      <button
                        className={`${selectedVote === vote ? "active" : ""}`}
                        onClick={() => setSelectedVote(vote)}
                        key={i}
                      >
                        {vote}
                      </button>
                    );
                  })}
                </div>
                <h4>Բիզնես գաղափար</h4>

                <div className="voting_rate">
                  {votes.map((vote, i) => {
                    return (
                      <button
                        className={`${selectedIdea === vote ? "active" : ""}`}
                        onClick={() => setSelectedIdea(vote)}
                        key={i}
                      >
                        {vote}
                      </button>
                    );
                  })}
                </div>
                <h4>Ներկայացման որակ</h4>
                <div className="voting_rate">
                  {votes.map((vote, i) => {
                    return (
                      <button
                        className={`${selectedEco === vote ? "active" : ""}`}
                        onClick={() => setSelectedEco(vote)}
                        key={i}
                      >
                        {vote}
                      </button>
                    );
                  })}
                </div>
              </div>
              <div className="voting_info_bottom">
                {minmax.max > 0 ? (
                  <>
                    <input
                      value={amount}
                      type="text"
                      placeholder="֏ Enter an amount"
                      onChange={handleInputChange}
                    />
                    <p className={`obsalute ${show ? "active" : ""}`}>
                      ֏ {formatNumberWithCommas(minmax.min)} -{" "}
                      {formatNumberWithCommas(minmax.max)}
                    </p>
                  </>
                ) : (
                  ""
                )}
                <button className="confirm" onClick={handleSubmit}>
                  Confirm
                </button>
                {errMssg && <p className="err">{errorText}</p>}
              </div>
            </div>
          </>
        ) : (
          <div className="loading">
            <span></span>
          </div>
        )}
      </div>
    </div>
  );
};
